import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  background_1920: require("../../../assets/wc/videos/background_1920x1080_v2.webm"),
};

export default assets;
